import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  maintWrapper: {
    height: '100%',
  },
  contentWrapper: {
    justifyContent: 'center',
  },
  table: {
    display: 'table',
    height: '100%',
    margin: 'auto',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
      width: '75%',
    },
  },
  tableRow: {
    display: 'table-row',
  },
  switcherWrapper: {
    float: 'right',
  },
  tableCellHeader: {
    display: 'table-cell',
  },
  tableCellBody: {
    display: 'table-cell',
    height: '100%',
    verticalAlign: 'middle',
  },
  tableCellFooter: {
    display: 'table-cell',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  illustrationSection: {
    backgroundColor: colors.gainsboro,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  logo: {
    width: 84,
    height: 24,
  },
}));
